import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { KickPlayer } from "../../common/game/GameControl";
import { playerLeft } from "../../slice/gameStateSlice";
import LogRocket from "logrocket";
import DcDialog from "../Dialogs/DcDialog";

const RemovePlayerButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [playerToKick, setPlayerToKick] = useState(null); // { index, name }
  const dispatch = useDispatch();
  const gameState = useSelector((state) => state.gameState);
  const user = useSelector((state) => state.auth.user);

  const handleRemovePlayer = useCallback(
    (index, playerName) => {
      KickPlayer(gameState.GameCode, index, user.Id, () => {
        dispatch(playerLeft(index));
        LogRocket.log("Kicked Player " + playerName, { GameCode: gameState.GameCode });
        setIsModalOpen(false);
        setPlayerToKick(null);
      });
    },
    [dispatch, gameState.GameCode, user.Id]
  );

  const handleConfirmKick = useCallback(() => {
    if (playerToKick) {
      const { index, name } = playerToKick;
      setPlayerToKick(null); // Close dialog immediately
      handleRemovePlayer(index, name);
    }
  }, [playerToKick, handleRemovePlayer]);

  const handleCancelKick = useCallback(() => {
    setPlayerToKick(null);
  }, []);

  if (user.Id !== gameState.GameCreatorId) return null;

  return (
    <>
      {!playerToKick && (
        <button className="btn BackToMenu me-2 mt-2" onClick={() => setIsModalOpen(true)}>
          Remove Player
        </button>
      )}
      {isModalOpen && !playerToKick && (
        <div
          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => setIsModalOpen(false)}
        >
          <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', minWidth: '200px' }} onClick={(e) => e.stopPropagation()}>
            <h5>Remove Player</h5>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {gameState.ActivePlayers.map((p, idx) => (
                <li
                  key={p.PlayerId}
                  style={{ padding: '10px 8px', cursor: 'pointer', borderBottom: '1px solid #eee', backgroundColor: '#f8f9fa' }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                  onClick={(e) => {
                    e.stopPropagation();
                    setPlayerToKick({ index: idx, name: p.PlayerName });
                  }}
                >
                  {p.PlayerName}
                </li>
              ))}
            </ul>
            <button className="btn btn-secondary btn-sm mt-2" onClick={() => setIsModalOpen(false)}>Cancel</button>
          </div>
        </div>
      )}
      <DcDialog
        isOpen={!!playerToKick}
        title="Kick player?"
        body={playerToKick ? `Are you sure you want to remove ${playerToKick.name} from the game?` : ""}
        confirmLabel="Yes, Remove"
        cancelLabel="Cancel"
        variant="danger"
        onConfirm={handleConfirmKick}
        onCancel={handleCancelKick}
      />
    </>
  );
};

export default RemovePlayerButton;
